export const VIP_TIER_DISCOUNT_OPTIONS = [
  { label: '5%', value: 5 },
  { label: '10%', value: 10 },
  { label: '15%', value: 15 },
  { label: '20%', value: 20 },
  { label: '25%', value: 25 },
  { label: '30%', value: 30 },
  { label: '40%', value: 40 },
  { label: '50%', value: 50 },
];

export const VIP_TIER_SPEND_AMOUNT_THRESHOLD_OPTIONS = [
  { label: '$1,000+', value: '1000' },
  { label: '$2,000+', value: '2000' },
  { label: '$3,000+', value: '3000' },
  { label: '$5,000+', value: '5000' },
  { label: '$10,000+', value: '10000' },
];

export const VIP_TIER_RESERVATION_COUNT_THRESHOLD_OPTIONS = [
  { label: '5+', value: '5' },
  { label: '10+', value: '10' },
  { label: '15+', value: '15' },
  { label: '20+', value: '20' },
];

export const VIP_TIER_PERIOD_OPTIONS = [
  { label: 'All time', value: 0 },
  { label: 'Last 30 days', value: 30 },
  { label: 'Last 90 days', value: 90 },
  { label: 'Last 6 months', value: 180 },
  { label: 'Last 12 months', value: 365 },
];
